<template>
    <div>
        <div v-if="currentAsset">
            <asset-navbar :filterMarket="currentAsset.market">
                <template v-slot:title>
                    {{ currentAsset.symbol }}
                </template>
                <template v-slot:subTitle>
                    config
                </template>
            </asset-navbar>

            <rounded-container variant="dark">
                <template v-slot:title>Asset config</template>

                <div class="p-3">
                    <b-button v-if="currentAsset.status !== 'disabled'" variant="outline-danger" @click.prevent="openDisable">
                        <b-icon icon="trash" aria-hidden="true"></b-icon> Disable {{ currentAsset.symbol }}
                    </b-button>
                    <b-button v-else variant="outline-success" @click.prevent="openEnable">
                        Re-enable {{ currentAsset.symbol }}
                    </b-button>
                </div>
            </rounded-container>
        </div>
        <div
            v-else-if="assetLoadFailed"
            class="text-center text-secondary py-5"
        >
            Unable to retrieve asset data
        </div>
        <div v-else class="text-center text-secondary py-5">
            Loading {{ symbol }}...
        </div>
    </div>
</template>

<script>

import RoundedContainer from '@/components/style/RoundedContainer.vue';
import AssetNavbar from '@/components/AssetNavbar.vue';
import DisableAsset from '@/components/overlays/DisableAsset.vue';
import EnableAsset from '@/components/overlays/EnableAsset.vue';

import { SHEET_STYLE } from '@/constants/ui';

export default {
    name: 'AssetConfig',
    components: { RoundedContainer, AssetNavbar },
    props: ['symbol'],
    data() {
        return {
            assetLoadFailed: false,
        }
    },
    async created() {
        if (this.currentAsset) return;

        try {
            // the live sync only ships active assets; a disabled one needs this to ever show up here
            await this.$store.dispatch('loadAssetList');
        } catch (error) {
            this.assetLoadFailed = true;
            return;
        }

        if (!this.currentAsset) this.assetLoadFailed = true;
    },
    computed: {
        currentAsset() {
            return this.$store.getters.getAssetBySymbol(this.symbol);
        },
    },
    methods: {
        openDisable() {
            this.$FModal.show(
                { component: DisableAsset, ...SHEET_STYLE },
                { currentAsset: this.currentAsset, onDone: this.backToAsset }
            );
        },
        openEnable() {
            this.$FModal.show(
                { component: EnableAsset, ...SHEET_STYLE },
                { currentAsset: this.currentAsset, onDone: this.backToAsset }
            );
        },
        backToAsset() {
            this.$router.push({ name: 'asset', params: { symbol: this.symbol } });
        },
    },
};
</script>
